import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  Tabs,
} from 'antd';
import {
  myLeadsHeaderAtom,
} from '../../../../../atoms/Atoms';
import {
  thousand,
} from '../../../../../functions';
import LeadsSearchTable from './LeadsSearchTable';

function LeadsPending({ className, orgReferral, useGlobal, isSetter }) {
  const { t } = useTranslation();
  const myLeadsHeader = useRecoilValue(myLeadsHeaderAtom);
  const { TabPane } = Tabs;
  const [selectedTab, setSlectedTab] = useState('assigned');

  return (
    <div className={className}>
      <Tabs activeKey={selectedTab} onChange={(tab) => setSlectedTab(tab)}>
        {(isSetter || useGlobal) && (
          <TabPane key="notassigned" tab={`${t('not_assigned')} (${thousand(myLeadsHeader?.totalNotAssigned)})`}>
            {selectedTab === 'notassigned' && (
              <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={1} />
            )}
          </TabPane>
        )}
        <TabPane key="assigned" tab={`${t('assigned')} (${thousand(myLeadsHeader?.totalPendingAssigned)})`}>
          {selectedTab === 'assigned' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={3} />
          )}
        </TabPane>
        <TabPane key="no_appointment" tab={`${t('no_appointment')} (${thousand(myLeadsHeader?.totalPendingNoAppointment)})`}>
          {selectedTab === 'no_appointment' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={4} />
          )}
        </TabPane>
      </Tabs>
    </div>
  );
}

export default LeadsPending;
